module.exports = __webpack_public_path__ + "img/main_visual_animal02.d06a5247.svg";